/* @flow strict */

import * as React from 'react';
import { Link, useParams } from 'react-router-dom';
import Settings from './settings';
import MapLabels from './mapLabels';

type PropsType = {
    eventId: number | string
};

const EventBadgePrinting = ({ eventId }: PropsType): React.Element<'div'> => {
    const { tableTab } = useParams();
    const _viewTab = tableTab ? tableTab.toLowerCase() : 'settings';

    return (
        <div className='badge-printing'>
            <div className="navbar-page-toolbar customers-navbar">
                <div className="container-fluid" style={{ height: '50px' }}>
                    <ul className="nav">
                        <li
                          key={'menuItems-1'}
                          className={`${(_viewTab) === 'settings' ? 'active' : ''}`}
                        >
                            <Link to={`/events/${eventId}/manage/badge-printing/settings`}>
                                Badge Printing
                            </Link>
                        </li>
                        <li
                          key={'menuItems-2'}
                          className={`${(_viewTab) === 'map-labels' ? 'active' : ''}`}
                        >
                            <Link to={`/events/${eventId}/manage/badge-printing/map-labels`}>
                                Map Labels
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            {_viewTab === 'settings' ?
                <Settings
                  eventId={eventId}
                />
                :
                <MapLabels
                  eventId={eventId}
                />
            }
        </div>
    );
};

export default EventBadgePrinting;